module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATCAYAAAB2pebxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAECSURBVHgBlVQBEYMwDGynoBIqAQl1MByAg+FgSJiDMQW7KYAp2ByAA3CQJUcCPY6W7u/+ciTpJ21TtAoAAEo0Z6RBTsiX1rpRKcDFFvmBffQUPxIwnEgYkTUyR1aen6yJiVShilxAOqxjIpJUBuJOuoyJCGxCzrKl0yZnYGsDAosfb2oKibzZFmof4u9UpFXntXuVlvlQL16sVDHwtW5nY/S+6yMBGrQW4uiDB4+BzKtI9gbzoDlmA+vAEYq9DiShhcBEct7TK5T5wbsIqARwV2s+qwtsoojxtu5oTnKO0VMfUkR40B78mZOI7KtT/6Fja0nku3GmYmA7P0aI/R8ikHU/kTCk5XN8thEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/icon-username.png
// module id = WYE9
// module chunks = 0